// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.friends-panel {
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: var(--bg-primary);
  height: 100%;
  color: var(--text-primary);
  font-family: 'Inter', sans-serif;
  overflow: hidden;
}

.friends-header {
  height: var(--header-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  border-bottom: 1px solid var(--glass-border);
  background: var(--glass-bg);
  backdrop-filter: var(--glass-blur);
  z-index: 10;
  flex-shrink: 0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.header-icon-main {
  color: var(--text-secondary);
}

.friends-header h1 {
  font-size: 16px;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.01em;
}

.header-divider {
  width: 1px;
  height: 24px;
  background-color: var(--glass-border);
  margin: 0 8px;
}

.friends-tabs {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tab-btn {
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all var(--transition-fast);
}

.tab-btn:hover {
  background-color: var(--bg-modifier-hover);
  color: var(--text-primary);
}

.tab-btn.active {
  background-color: var(--bg-modifier-selected);
  color: var(--text-bright);
}

.tab-badge {
  background-color: var(--brand-primary);
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  font-weight: 700;
}

.tab-badge.secondary {
  background-color: var(--bg-modifier-active);
  color: var(--text-secondary);
}

.add-tab-btn {
  color: var(--success);
}

.add-tab-btn:hover {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--success);
}

.add-tab-btn.active {
  background-color: var(--success);
  color: white;
}

/* Content Area */
.friends-content-container {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.friends-list-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  overflow: hidden;
}

.friends-search {
  display: flex;
  align-items: center;
  background-color: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: var(--radius-md);
  padding: 10px 14px;
  gap: 10px;
  margin-bottom: 20px;
}

.friends-search input {
  background: none;
  border: none;
  outline: none;
  color: var(--text-primary);
  font-size: 14px;
  width: 100%;
}

.friends-count-header {
  font-size: 11px;
  font-weight: 800;
  color: var(--text-muted);
  letter-spacing: 0.05em;
  margin-bottom: 12px;
  padding-left: 8px;
}

.friends-scroll-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-right: 4px;
}

/* Card item */
.friend-row-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: var(--radius-md);
  border: 1px solid var(--glass-border);
  background-color: rgba(255, 255, 255, 0.01);
  transition: all var(--transition-fast);
}

.friend-card-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.friend-avatar-wrapper {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: var(--radius-full);
  overflow: visible;
  flex-shrink: 0;
}

.friend-avatar-wrapper img {
  width: 100%;
  height: 100%;
  border-radius: var(--radius-full);
  object-fit: cover;
}

.avatar-placeholder-letter {
  width: 100%;
  height: 100%;
  border-radius: var(--radius-full);
  background-color: var(--brand-primary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
}

.status-dot {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 14px;
  height: 14px;
  border-radius: var(--radius-full);
  border: 3px solid var(--bg-primary);
}

.status-dot.online { background-color: var(--status-online); }
.status-dot.idle { background-color: var(--status-idle); }
.status-dot.dnd { background-color: var(--status-dnd); }
.status-dot.offline { background-color: var(--status-offline); }

.friend-meta-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.friend-name-display {
  display: flex;
  align-items: center;
  gap: 6px;
}

.display-name {
  font-weight: 600;
  font-size: 15px;
  color: var(--text-primary);
}

.username-tag {
  font-size: 12px;
  color: var(--text-muted);
}

.friend-activity-status {
  font-size: 13px;
  color: var(--text-secondary);
}

.custom-status {
  color: var(--brand-light);
  font-style: italic;
}

.action-circle-btn {
  width: 38px;
  height: 38px;
  border-radius: var(--radius-full);
  background-color: var(--bg-modifier-hover);
  border: 1px solid var(--glass-border);
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.action-circle-btn:hover {
  background-color: var(--brand-primary);
  color: white;
  transform: scale(1.05);
}

.action-circle-btn.accept-action-btn:hover {
  background-color: #10b981;
  color: white;
  border-color: #10b981;
}

.action-circle-btn.reject-action-btn:hover,
.action-circle-btn.cancel-action-btn:hover,
.action-circle-btn.remove-btn:hover {
  background-color: #ef4444;
  color: white;
  border-color: #ef4444;
}

.tab-badge.warning-badge {
  background-color: #ef4444;
  color: white;
}

.tab-badge.danger-badge {
  background-color: #dc2626;
  color: white;
}

.incoming-tag {
  font-size: 11px;
  color: #10b981;
  font-weight: 600;
}

.blocked-tag {
  font-size: 11px;
  color: #ef4444;
  font-weight: 600;
}

.unblock-action-btn {
  background: rgba(220, 38, 38, 0.15);
  color: #f87171;
  border: 1px solid rgba(239, 68, 68, 0.35);
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.unblock-action-btn:hover {
  background: #dc2626;
  color: white;
  border-color: #dc2626;
  transform: scale(1.02);
}

.friend-card-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.add-user-btn.pending-btn {
  background-color: var(--bg-modifier-hover);
  color: var(--text-muted);
  cursor: not-allowed;
  border: 1px solid var(--glass-border);
}

.add-user-btn.accept-btn {
  background-color: #10b981;
  color: white;
}

/* Empty State */
.friends-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 40px;
  text-align: center;
  color: var(--text-secondary);
}

.empty-icon-container {
  width: 80px;
  height: 80px;
  border-radius: var(--radius-full);
  background: var(--bg-modifier-hover);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  color: var(--text-muted);
}

.friends-empty-state h3 {
  font-size: 18px;
  margin-bottom: 8px;
  color: var(--text-primary);
}

.friends-empty-state p {
  font-size: 14px;
  max-width: 320px;
}

/* Add Friend View */
.add-friend-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 30px;
  overflow: hidden;
}

.add-friend-header-box {
  background: linear-gradient(135deg, rgba(153, 27, 27, 0.1) 0%, rgba(2, 6, 23, 0.4) 100%);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-lg);
  padding: 24px;
  margin-bottom: 30px;
}

.add-friend-header-box h2 {
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
}

.add-friend-header-box p {
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: 20px;
}

.add-friend-search-input {
  display: flex;
  align-items: center;
  background-color: var(--bg-primary);
  border: 1px solid var(--input-border);
  border-radius: var(--radius-md);
  padding: 6px 8px 6px 16px;
  gap: 12px;
  transition: all 0.2s ease;
}

.add-friend-search-input:focus-within {
  border-color: var(--brand-primary);
  box-shadow: 0 0 0 2px rgba(153, 27, 27, 0.2);
}

.add-friend-search-input.success-border {
  border-color: #22c55e !important;
}

.add-friend-search-input.error-border {
  border-color: #ef4444 !important;
}

.add-friend-search-input input {
  background: none;
  border: none;
  outline: none;
  color: white;
  flex: 1;
  font-size: 14px;
}

.send-friend-request-btn {
  background: #5865f2;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.send-friend-request-btn:hover:not(:disabled) {
  background: #4752c4;
}

.send-friend-request-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.add-friend-status-msg {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  font-size: 13px;
  font-weight: 500;
}

.add-friend-status-msg.success {
  color: #22c55e;
}

.add-friend-status-msg.error {
  color: #ef4444;
}

.add-friend-discord-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: var(--text-secondary);
  padding: 40px;
}

.add-friend-discord-empty h3 {
  font-size: 18px;
  font-weight: 700;
  color: #f8fafc;
  margin-bottom: 8px;
}

.add-friend-discord-empty p {
  font-size: 13px;
  color: #94a3b8;
  max-width: 360px;
  line-height: 1.5;
}

.users-discover-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.users-discover-list h3 {
  font-size: 11px;
  font-weight: 800;
  color: var(--text-muted);
  letter-spacing: 0.05em;
  margin-bottom: 16px;
}

.users-scroll-grid {
  flex: 1;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
  padding-bottom: 20px;
  padding-right: 4px;
}

.user-discover-card {
  background-color: rgba(255, 255, 255, 0.02);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-md);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all var(--transition-normal);
}

.discover-card-banner {
  height: 60px;
  background-color: var(--brand-primary);
}

.discover-card-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -36px;
  flex: 1;
}

.discover-avatar-container {
  width: 60px;
  height: 60px;
  border-radius: var(--radius-full);
  border: 4px solid var(--bg-primary);
  position: relative;
  overflow: visible;
  margin-bottom: 12px;
  background-color: var(--bg-secondary);
}

.discover-avatar-img {
  width: 100%;
  height: 100%;
  border-radius: var(--radius-full);
  object-fit: cover;
}

.discover-avatar-letter {
  width: 100%;
  height: 100%;
  border-radius: var(--radius-full);
  background-color: var(--brand-primary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 22px;
}

.discover-user-meta {
  text-align: center;
  margin-bottom: 20px;
  flex: 1;
  width: 100%;
}

.discover-display-name {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.discover-username {
  font-size: 12px;
  color: var(--text-muted);
  display: block;
  margin-bottom: 10px;
}

.discover-bio {
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.4;
  height: 38px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.add-user-btn {
  width: 100%;
  background: var(--brand-primary);
  border: none;
  color: white;
  padding: 8px 16px;
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all var(--transition-fast);
}

.add-user-btn:hover:not(:disabled) {
  filter: brightness(1.15);
  transform: translateY(-1px);
}

.add-user-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.discover-empty-state {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px;
  color: var(--text-secondary);
}

.empty-sparkle {
  color: var(--warning);
  margin-bottom: 15px;
  animation: pulse 2s infinite;
}

.discover-empty-state h4 {
  font-size: 16px;
  margin-bottom: 6px;
  color: var(--text-primary);
}

/* Sidebar "Active Now" */
.friends-active-now {
  width: 320px;
  border-left: 1px solid var(--glass-border);
  background-color: rgba(0, 0, 0, 0.15);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex-shrink: 0;
}

.friends-active-now h2 {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.active-now-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  overflow-y: auto;
}

.active-friend-mini-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-radius: var(--radius-md);
  background: var(--bg-primary);
  border: 1px solid var(--glass-border);
}

.mini-card-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.mini-avatar {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-full);
  position: relative;
  flex-shrink: 0;
}

.mini-avatar img {
  width: 100%;
  height: 100%;
  border-radius: var(--radius-full);
  object-fit: cover;
}

.mini-avatar-letter {
  width: 100%;
  height: 100%;
  border-radius: var(--radius-full);
  background-color: var(--brand-primary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
}

.mini-details {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.mini-name {
  font-size: 13px;
  font-weight: 700;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mini-status-text {
  font-size: 11px;
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.active-pulse-dot {
  width: 8px;
  height: 8px;
  background-color: var(--success);
  border-radius: var(--radius-full);
  box-shadow: 0 0 8px var(--success);
}

.active-now-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 10px;
  text-align: center;
  color: var(--text-muted);
  gap: 12px;
  height: 100%;
}

.active-now-empty h4 {
  font-size: 14px;
  color: var(--text-secondary);
}

.active-now-empty p {
  font-size: 12px;
}

/* Animations & Responsive */
@keyframes pulse {
  0% { transform: scale(1); opacity: 0.8; }
  50% { transform: scale(1.1); opacity: 1; }
  100% { transform: scale(1); opacity: 0.8; }
}

@media (max-width: 1000px) {
  .friends-active-now {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FriendsPanel/FriendsPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,mCAAmC;EACnC,YAAY;EACZ,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,4CAA4C;EAC5C,2BAA2B;EAC3B,kCAAkC;EAClC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA,qBAAqB,sCAAsC,EAAE;AAC7D,mBAAmB,oCAAoC,EAAE;AACzD,kBAAkB,mCAAmC,EAAE;AACvD,sBAAsB,uCAAuC,EAAE;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,0CAA0C;EAC1C,qCAAqC;EACrC,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0CAA0C;EAC1C,wBAAwB;EACxB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,wFAAwF;EACxF,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,qCAAqC;EACrC,+BAA+B;EAC/B,yBAAyB;EACzB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,OAAO;EACP,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,0CAA0C;EAC1C,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,+BAA+B;EAC/B,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,KAAK,mBAAmB,EAAE,YAAY,EAAE;EACxC,MAAM,qBAAqB,EAAE,UAAU,EAAE;EACzC,OAAO,mBAAmB,EAAE,YAAY,EAAE;AAC5C;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".friends-panel {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  background-color: var(--bg-primary);\n  height: 100%;\n  color: var(--text-primary);\n  font-family: 'Inter', sans-serif;\n  overflow: hidden;\n}\n\n.friends-header {\n  height: var(--header-height);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n  border-bottom: 1px solid var(--glass-border);\n  background: var(--glass-bg);\n  backdrop-filter: var(--glass-blur);\n  z-index: 10;\n  flex-shrink: 0;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n.header-icon-main {\n  color: var(--text-secondary);\n}\n\n.friends-header h1 {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--text-primary);\n  letter-spacing: -0.01em;\n}\n\n.header-divider {\n  width: 1px;\n  height: 24px;\n  background-color: var(--glass-border);\n  margin: 0 8px;\n}\n\n.friends-tabs {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tab-btn {\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 14px;\n  font-weight: 600;\n  padding: 6px 12px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  transition: all var(--transition-fast);\n}\n\n.tab-btn:hover {\n  background-color: var(--bg-modifier-hover);\n  color: var(--text-primary);\n}\n\n.tab-btn.active {\n  background-color: var(--bg-modifier-selected);\n  color: var(--text-bright);\n}\n\n.tab-badge {\n  background-color: var(--brand-primary);\n  color: white;\n  font-size: 10px;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-weight: 700;\n}\n\n.tab-badge.secondary {\n  background-color: var(--bg-modifier-active);\n  color: var(--text-secondary);\n}\n\n.add-tab-btn {\n  color: var(--success);\n}\n\n.add-tab-btn:hover {\n  background-color: rgba(16, 185, 129, 0.1);\n  color: var(--success);\n}\n\n.add-tab-btn.active {\n  background-color: var(--success);\n  color: white;\n}\n\n/* Content Area */\n.friends-content-container {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n.friends-list-wrapper {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  overflow: hidden;\n}\n\n.friends-search {\n  display: flex;\n  align-items: center;\n  background-color: var(--input-bg);\n  border: 1px solid var(--input-border);\n  border-radius: var(--radius-md);\n  padding: 10px 14px;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.friends-search input {\n  background: none;\n  border: none;\n  outline: none;\n  color: var(--text-primary);\n  font-size: 14px;\n  width: 100%;\n}\n\n.friends-count-header {\n  font-size: 11px;\n  font-weight: 800;\n  color: var(--text-muted);\n  letter-spacing: 0.05em;\n  margin-bottom: 12px;\n  padding-left: 8px;\n}\n\n.friends-scroll-list {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-right: 4px;\n}\n\n/* Card item */\n.friend-row-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--glass-border);\n  background-color: rgba(255, 255, 255, 0.01);\n  transition: all var(--transition-fast);\n}\n\n.friend-card-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.friend-avatar-wrapper {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-full);\n  overflow: visible;\n  flex-shrink: 0;\n}\n\n.friend-avatar-wrapper img {\n  width: 100%;\n  height: 100%;\n  border-radius: var(--radius-full);\n  object-fit: cover;\n}\n\n.avatar-placeholder-letter {\n  width: 100%;\n  height: 100%;\n  border-radius: var(--radius-full);\n  background-color: var(--brand-primary);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.status-dot {\n  position: absolute;\n  bottom: -2px;\n  right: -2px;\n  width: 14px;\n  height: 14px;\n  border-radius: var(--radius-full);\n  border: 3px solid var(--bg-primary);\n}\n\n.status-dot.online { background-color: var(--status-online); }\n.status-dot.idle { background-color: var(--status-idle); }\n.status-dot.dnd { background-color: var(--status-dnd); }\n.status-dot.offline { background-color: var(--status-offline); }\n\n.friend-meta-details {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.friend-name-display {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.display-name {\n  font-weight: 600;\n  font-size: 15px;\n  color: var(--text-primary);\n}\n\n.username-tag {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.friend-activity-status {\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.custom-status {\n  color: var(--brand-light);\n  font-style: italic;\n}\n\n.action-circle-btn {\n  width: 38px;\n  height: 38px;\n  border-radius: var(--radius-full);\n  background-color: var(--bg-modifier-hover);\n  border: 1px solid var(--glass-border);\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.action-circle-btn:hover {\n  background-color: var(--brand-primary);\n  color: white;\n  transform: scale(1.05);\n}\n\n.action-circle-btn.accept-action-btn:hover {\n  background-color: #10b981;\n  color: white;\n  border-color: #10b981;\n}\n\n.action-circle-btn.reject-action-btn:hover,\n.action-circle-btn.cancel-action-btn:hover,\n.action-circle-btn.remove-btn:hover {\n  background-color: #ef4444;\n  color: white;\n  border-color: #ef4444;\n}\n\n.tab-badge.warning-badge {\n  background-color: #ef4444;\n  color: white;\n}\n\n.tab-badge.danger-badge {\n  background-color: #dc2626;\n  color: white;\n}\n\n.incoming-tag {\n  font-size: 11px;\n  color: #10b981;\n  font-weight: 600;\n}\n\n.blocked-tag {\n  font-size: 11px;\n  color: #ef4444;\n  font-weight: 600;\n}\n\n.unblock-action-btn {\n  background: rgba(220, 38, 38, 0.15);\n  color: #f87171;\n  border: 1px solid rgba(239, 68, 68, 0.35);\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.unblock-action-btn:hover {\n  background: #dc2626;\n  color: white;\n  border-color: #dc2626;\n  transform: scale(1.02);\n}\n\n.friend-card-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.add-user-btn.pending-btn {\n  background-color: var(--bg-modifier-hover);\n  color: var(--text-muted);\n  cursor: not-allowed;\n  border: 1px solid var(--glass-border);\n}\n\n.add-user-btn.accept-btn {\n  background-color: #10b981;\n  color: white;\n}\n\n/* Empty State */\n.friends-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  padding: 40px;\n  text-align: center;\n  color: var(--text-secondary);\n}\n\n.empty-icon-container {\n  width: 80px;\n  height: 80px;\n  border-radius: var(--radius-full);\n  background: var(--bg-modifier-hover);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n  color: var(--text-muted);\n}\n\n.friends-empty-state h3 {\n  font-size: 18px;\n  margin-bottom: 8px;\n  color: var(--text-primary);\n}\n\n.friends-empty-state p {\n  font-size: 14px;\n  max-width: 320px;\n}\n\n/* Add Friend View */\n.add-friend-wrapper {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 30px;\n  overflow: hidden;\n}\n\n.add-friend-header-box {\n  background: linear-gradient(135deg, rgba(153, 27, 27, 0.1) 0%, rgba(2, 6, 23, 0.4) 100%);\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-lg);\n  padding: 24px;\n  margin-bottom: 30px;\n}\n\n.add-friend-header-box h2 {\n  font-size: 15px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  margin-bottom: 8px;\n}\n\n.add-friend-header-box p {\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin-bottom: 20px;\n}\n\n.add-friend-search-input {\n  display: flex;\n  align-items: center;\n  background-color: var(--bg-primary);\n  border: 1px solid var(--input-border);\n  border-radius: var(--radius-md);\n  padding: 6px 8px 6px 16px;\n  gap: 12px;\n  transition: all 0.2s ease;\n}\n\n.add-friend-search-input:focus-within {\n  border-color: var(--brand-primary);\n  box-shadow: 0 0 0 2px rgba(153, 27, 27, 0.2);\n}\n\n.add-friend-search-input.success-border {\n  border-color: #22c55e !important;\n}\n\n.add-friend-search-input.error-border {\n  border-color: #ef4444 !important;\n}\n\n.add-friend-search-input input {\n  background: none;\n  border: none;\n  outline: none;\n  color: white;\n  flex: 1;\n  font-size: 14px;\n}\n\n.send-friend-request-btn {\n  background: #5865f2;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 10px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n}\n\n.send-friend-request-btn:hover:not(:disabled) {\n  background: #4752c4;\n}\n\n.send-friend-request-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.add-friend-status-msg {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 12px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.add-friend-status-msg.success {\n  color: #22c55e;\n}\n\n.add-friend-status-msg.error {\n  color: #ef4444;\n}\n\n.add-friend-discord-empty {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: var(--text-secondary);\n  padding: 40px;\n}\n\n.add-friend-discord-empty h3 {\n  font-size: 18px;\n  font-weight: 700;\n  color: #f8fafc;\n  margin-bottom: 8px;\n}\n\n.add-friend-discord-empty p {\n  font-size: 13px;\n  color: #94a3b8;\n  max-width: 360px;\n  line-height: 1.5;\n}\n\n.users-discover-list {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.users-discover-list h3 {\n  font-size: 11px;\n  font-weight: 800;\n  color: var(--text-muted);\n  letter-spacing: 0.05em;\n  margin-bottom: 16px;\n}\n\n.users-scroll-grid {\n  flex: 1;\n  overflow-y: auto;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 16px;\n  padding-bottom: 20px;\n  padding-right: 4px;\n}\n\n.user-discover-card {\n  background-color: rgba(255, 255, 255, 0.02);\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  transition: all var(--transition-normal);\n}\n\n.discover-card-banner {\n  height: 60px;\n  background-color: var(--brand-primary);\n}\n\n.discover-card-content {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: -36px;\n  flex: 1;\n}\n\n.discover-avatar-container {\n  width: 60px;\n  height: 60px;\n  border-radius: var(--radius-full);\n  border: 4px solid var(--bg-primary);\n  position: relative;\n  overflow: visible;\n  margin-bottom: 12px;\n  background-color: var(--bg-secondary);\n}\n\n.discover-avatar-img {\n  width: 100%;\n  height: 100%;\n  border-radius: var(--radius-full);\n  object-fit: cover;\n}\n\n.discover-avatar-letter {\n  width: 100%;\n  height: 100%;\n  border-radius: var(--radius-full);\n  background-color: var(--brand-primary);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 22px;\n}\n\n.discover-user-meta {\n  text-align: center;\n  margin-bottom: 20px;\n  flex: 1;\n  width: 100%;\n}\n\n.discover-display-name {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.discover-username {\n  font-size: 12px;\n  color: var(--text-muted);\n  display: block;\n  margin-bottom: 10px;\n}\n\n.discover-bio {\n  font-size: 12px;\n  color: var(--text-secondary);\n  line-height: 1.4;\n  height: 38px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.add-user-btn {\n  width: 100%;\n  background: var(--brand-primary);\n  border: none;\n  color: white;\n  padding: 8px 16px;\n  border-radius: var(--radius-sm);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: all var(--transition-fast);\n}\n\n.add-user-btn:hover:not(:disabled) {\n  filter: brightness(1.15);\n  transform: translateY(-1px);\n}\n\n.add-user-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.discover-empty-state {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px;\n  color: var(--text-secondary);\n}\n\n.empty-sparkle {\n  color: var(--warning);\n  margin-bottom: 15px;\n  animation: pulse 2s infinite;\n}\n\n.discover-empty-state h4 {\n  font-size: 16px;\n  margin-bottom: 6px;\n  color: var(--text-primary);\n}\n\n/* Sidebar \"Active Now\" */\n.friends-active-now {\n  width: 320px;\n  border-left: 1px solid var(--glass-border);\n  background-color: rgba(0, 0, 0, 0.15);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  flex-shrink: 0;\n}\n\n.friends-active-now h2 {\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n\n.active-now-content {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.active-friend-mini-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px;\n  border-radius: var(--radius-md);\n  background: var(--bg-primary);\n  border: 1px solid var(--glass-border);\n}\n\n.mini-card-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.mini-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-full);\n  position: relative;\n  flex-shrink: 0;\n}\n\n.mini-avatar img {\n  width: 100%;\n  height: 100%;\n  border-radius: var(--radius-full);\n  object-fit: cover;\n}\n\n.mini-avatar-letter {\n  width: 100%;\n  height: 100%;\n  border-radius: var(--radius-full);\n  background-color: var(--brand-primary);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.mini-details {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.mini-name {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.mini-status-text {\n  font-size: 11px;\n  color: var(--text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.active-pulse-dot {\n  width: 8px;\n  height: 8px;\n  background-color: var(--success);\n  border-radius: var(--radius-full);\n  box-shadow: 0 0 8px var(--success);\n}\n\n.active-now-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 10px;\n  text-align: center;\n  color: var(--text-muted);\n  gap: 12px;\n  height: 100%;\n}\n\n.active-now-empty h4 {\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.active-now-empty p {\n  font-size: 12px;\n}\n\n/* Animations & Responsive */\n@keyframes pulse {\n  0% { transform: scale(1); opacity: 0.8; }\n  50% { transform: scale(1.1); opacity: 1; }\n  100% { transform: scale(1); opacity: 0.8; }\n}\n\n@media (max-width: 1000px) {\n  .friends-active-now {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
